import React, {useEffect} from 'react';
import Strings from "../Lang/strings";
import Input from "./Input";
import Map from './Map';
import mapSymbolTalabatey from '../assets/images/icons8-location-64.png'
import useCities from "../hooks/useCities";
import Select from "./Select";
import ZainBanner from "./ZainBanner";
import BannerWrapper from "./BannerWarrper";

const LocationStep = ({data, dataChangeHandler}) => {
    const {
        cities,
        setSelectedCity,
        selectedCity,
        districts,
        setSelectedDistrict,
        selectedDistrict,
    } = useCities(data.city_id, data.district_id);

    useEffect(() => {
        if (selectedDistrict && districts.length !== 0) {
            const selectedDistrictObject = districts.find((district) => district.id == selectedDistrict);

            if (!(!data.polygon && data.district_id && data.city_id)) { // if we already in step 3 and returned back to this step, then we have a location so, prevent setting the location of district is must
                dataChangeHandler("location", selectedDistrictObject.location);
            }
            if (selectedDistrictObject) {
                dataChangeHandler("polygon", selectedDistrictObject.polygon);
                dataChangeHandler("district_id", selectedDistrictObject.id);
            } else {
                dataChangeHandler("district_id", null);
            }
        }
    }, [selectedDistrict, districts]);

    const currentLang = Strings.getLanguage();
    const parseOptions = (options) => options.map(option => ({
        value: option.id,
        name: option.name[currentLang]
    }));
    const citiesOptions = parseOptions(cities);
    const districtsOptions = parseOptions(districts);
    const inputChangeHandler = (event) => {
        const {name, value} = event.target;
        dataChangeHandler(name, value);
    }
    return (
        <div className={"mt-12"}>
            <section>
                <div className={"flex justify-center items-center mt-3 mb-2 flex-col w-22"}>
                    <img className={"w-12 lg:w-20 md-16"} src={mapSymbolTalabatey} alt="map icon"/>
                    <h1 className={"text-center mt-1 capitalize text-gray-900  lg:text-2xl text-lg"}>{Strings.choseTheSimDeliveryLocation}</h1>
                    <p className={"text-center flex-grow-0 text-sm text-gray-600 mt-1 overflow-hidden lg:w-1/2"}>{Strings.requiredDocumentsAndInstructions}</p>
                    <BannerWrapper/>
                </div>
                <div className="w-full mb-2">
                    <Select title={'city'}
                            value={selectedCity}
                            name="city_id"
                            changeHandler={(e) => {
                                setSelectedCity(e);
                            }}
                            options={citiesOptions}/>
                </div>
                <div className="w-full mb-2">
                    <Select
                        value={selectedDistrict}
                        title={'district'} name="district_id"
                        changeHandler={(e) => {
                            setSelectedDistrict(e);
                        }}
                        options={districtsOptions}/>
                </div>

                <p className={"mb-2 mt-4 mx-1 text-sm text-gray-600"}>
                    * {Strings.selectToOpenMap}
                </p>

                <div className={"h-96 relative border-gray-400 border-2 rounded"}>
                    {
                        //to prevent render the map until the get request completed
                        data.location !== 0 &&
                        <Map marker={data.location} polygon={data.polygon} dataChangeHandler={dataChangeHandler}/>
                    }
                </div>
            </section>
            <section className={"lg:mt-10 mt-16 mb-5"}>
                <h2 className={"text-2xl my-1  capitalize text-gray-900"}>{Strings.moreDetails}</h2>
                <div className={"flex   flex-wrap gap-x-3"}>
                    <div className={` flex-grow lg:flex-1 md:flex-1 mb-2`}>
                        <Input min={1}
                               title={'street'}
                               type={"number"}
                               name={'street'}
                               value={data.street}
                               required={false}
                               handleChange={inputChangeHandler}
                               placeholder={'street'}/>
                    </div>
                    <div className={` flex-grow lg:flex-1 md:flex-1 mt-2 md:mt-0 lg:mt-0`}>
                        <Input min={1}
                               title={'building'}
                               type={"number"}
                               name={'building'}
                               value={data.building}
                               required={false}
                               handleChange={inputChangeHandler}
                               placeholder={'building'}/>
                    </div>
                </div>
                <div className={"flex flex-wrap gap-x-3"}>
                    <div className={`flex-grow lg:flex-1 md:flex-1 mt-2`}>
                        <Input min={1} title={'apartment'}
                               type={"number"}
                               name={'apartment'}
                               value={data.apartment}
                               required={false}
                               handleChange={inputChangeHandler}
                               placeholder={'apartment'}/>
                    </div>

                </div>
                <div className={`flex-grow lg:flex-1 md:flex-1 mt-2`}>
                    <Input title={'additionalInformationAboutLocation'}
                           name={"reference_point"}
                           type={"text"}
                           value={data.reference_point}
                           required={true}
                           handleChange={inputChangeHandler}
                           placeholder={'mentionAdditionalInformation'}/>
                </div>
            </section>

        </div>

    );
};

export default LocationStep;
